import React from 'react';
import Button from '@material-ui/core/Button';
import { withRouter } from 'react-router-dom'; 
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';

import Dialog from '../ui/Dialog';
import { postTransactionBatchPurchaseDisapprove ,getTransactionConfig} from '../../services/transaction.service';
import { TRANSACTIONS_CONSTANT, PROGRAMS_CONSTANT } from '../../constants/common';
import { includes, values } from 'lodash'; 

class TransactionBatchPurchaseDisapproveWithReason extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
      reason: ''
    };
  }
  componentDidMount() {
    const { connect_program_id } = this.props.match.params;
    this.getReasonsList(connect_program_id);
  }

  getReasonsList = async (programId) => {
    try {
      const { result } = await getTransactionConfig({
        program_id: programId,
      });
      const metadata = result?.transaction_metadata;
      const reasonObj = metadata?.transaction_rejection_reason?.en;
     
      const reasonsObjList = reasonObj.map(obj => {
        const key = Object.keys(obj)[0];
        return {
          label: obj[key].short,
          value: key
        };
      });
 
      this.setState({ reasonsList: reasonsObjList });
    } catch (err) {
      console.error("Failed to fetch reasons list", err);
    }
  }
  
  handleOpenModal = () => {
    this.setState({ openModal: true });
  };

  handleCloseModal = () => {
    this.setState({ openModal: false, reason: '' });
  };

  handleReasonChange = (e) => {
    this.setState({ reason: e.target.value });
  };

  handleDisapprove = async () => {
    const { transaction_batch_id, user_id } = this.props.data;
    const { connect_program_id } = this.props.match.params;
    const { reason } = this.state;

    if (!reason.trim()) {
      alert('Please select a reason.');
      return;
    }

    try {
      const res = await postTransactionBatchPurchaseDisapprove({
        connect_program_id,
        transaction_batch_id,
        user_id,
        reason,
      });
      alert(res.message);
      window.location.reload();
    } catch (err) {
      alert(err.message);
    }
  };

  render() {
    const { transaction_status, transaction_type } = this.props.data;
    const { connect_program_id } = this.props.match.params;
    const { openModal, reason, reasonsList = [] } = this.state;
    

    const medkakiProgramIDList = values(PROGRAMS_CONSTANT.PROGRAM_ID.MEDKAKI);
    const isMedkaki = includes(medkakiProgramIDList, connect_program_id);

    return  (
      <>      
      { transaction_type !== TRANSACTIONS_CONSTANT.TRANSACTION_TYPE.REDEEM ? <>
        <Button variant="contained" onClick={this.handleOpenModal} style={{ marginRight: 5 }}>
          Disapprove with Reason
        </Button>
        </> : null}
        <Dialog
          open={openModal}
          onClose={this.handleCloseModal}
          title="Disapprove Transaction"
          style={{ Width: '800px', marginTop:'-20px' }}
        >
          <div style={{marginTop : '-150px'}}> Select Reason
              <Select
              labelId="reason-select-label"
              value={reason}
              onChange={this.handleReasonChange}
              label="Reason for disapproval"
              style={{width : '250px'}}
            >
              {reasonsList.map((reasonObj) => (
                <MenuItem key={reasonObj.value} value={reasonObj.value}>
                  {reasonObj.label}
                </MenuItem>
              ))}
            </Select>
            </div>
            <div style={{ marginTop: 16, display: 'flex', justifyContent: 'flex-end' }}>
              <Button onClick={this.handleCloseModal} style={{ marginRight: 8 }}>
                Cancel
              </Button>
              <Button
                onClick={this.handleDisapprove}
                color="secondary"
                variant="contained"
              >
                Submit
              </Button>
            </div>
          
        </Dialog>
      </>
    );
  }
}

export default withRouter(TransactionBatchPurchaseDisapproveWithReason);
